module.exports = __webpack_public_path__ + "media/a1c5be3fca4f409c890d0d0a4f23f317.641bb5fd.mp4";